import React from 'react';

import LabelTag from './LabelTag';
import SpinLoader from '../shared/SpinLoader';

const LabelDropdown = ({ options, showOptions, activeIndex, setActiveIndex, onMouseDown }) => {
    if (options === null) {
        return (
            <div className={'suggestions-dropdown' + (showOptions ? ' show' : ' hide')}>
                <div className='dd-item text-center'>
                    <br />
                    <SpinLoader isLoading />
                </div>
            </div>
        );
    }

    if (!options.length) {
        return (
            <div className={'suggestions-dropdown' + (showOptions ? ' show' : ' hide')}>
                <div className='dd-item text-center'>Inga träffar...</div>
            </div>
        );
    }

    return (
        <div className={'suggestions-dropdown' + (showOptions ? ' show' : ' hide')}>
            {options.map((value, index) => {
                if (!value) return null;
                let className = `dd-item ${index === activeIndex ? ' dd-item-active' : null}`;
                return (
                    <div
                        id={`suggestion-${index}`}
                        key={value.id ?? value.name ?? 'null'}
                        onMouseDown={onMouseDown}
                        onMouseOver={() => setActiveIndex(index)}
                        className={className}>
                        <LabelTag {...{ value }} />
                    </div>
                );
            })}
        </div>
    );
};

export default LabelDropdown;
